import './simplyplated/style';
import FormStructure from './simplyplated/form_structure';

export default FormStructure;